import { axiosInstance } from "./apiConfig"

export const apiCreateBooking = async ({
    storeId,
    VisitDate,
    VisitTime,
    SpecialRequests,
    PromotionId,
    PartySize,
    name,
    surname,
    mobilePhone,
    email,
    mobilePhoneCountryCode,
    PaymentMethodId = null,
    PaymentIntentId = null,
    receiveEmailMarketing = false,
    emailMarketingOptInText = '',
}) => {
    let optionalFields = '';
    if (PaymentMethodId) {
        optionalFields += `&PaymentMethodId=${PaymentMethodId}`;
    }
    if (PaymentIntentId) {
        optionalFields += `&PaymentIntentId=${PaymentIntentId}`;
    }

    const response = await axiosInstance.post(
        `/thirdparty/resdiary/store/${storeId}/booking/bookingWithStripeToken`,
        `VisitDate=${VisitDate}&VisitTime=${VisitTime}&PartySize=${PartySize}` +
        `&Customer[FirstName]=${name}&Customer[Surname]=${surname}` +
        `&Customer[MobileCountryCode]=${mobilePhoneCountryCode}` +
        `&Customer[Mobile]=${mobilePhone}` +
        `&SpecialRequests=${SpecialRequests}` +
        `&PromotionId=${PromotionId || null}` +
        `&Customer[Email]=${email}` +
        `&IsLeaveTimeConfirmed=false` +
        `&Customer[ReceiveEmailMarketing]=${receiveEmailMarketing}` +
        `&Customer[ReceiveRestaurantEmailMarketing]=${receiveEmailMarketing}` +
        `&Customer[GroupEmailMarketingOptInText]=${emailMarketingOptInText}` +
        `&Customer[RestaurantEmailMarketingOptInText]=${emailMarketingOptInText}` +
        optionalFields,
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
    );
    return response.data;
}


// WEBPACK FOOTER //
// ./src/api/createBooking.js